module.exports = __webpack_public_path__ + "static/media/shorts.26b8c028.jpg";